import { observer } from 'mobx-react';
import * as React from 'react';

import { Tab } from './Tab';

interface ITabContainerMobileProps {
  tabs: Array<{
    isCompleted: boolean;
    isBeforeSelected?: boolean;
    isAfterSelected?: boolean;
    id: number | string;
    name: string;
    title: string;
    isSelected: boolean;
    type?: string | number;
  }>;
  onSelectedTab?(id?: number | string): void;
}

@observer
export class TabContainerMobile extends React.Component<ITabContainerMobileProps> {
  public render() {
    const { tabs, onSelectedTab } = this.props;

    return (
      <div>
        {tabs.map(({ isCompleted, isAfterSelected, isBeforeSelected, id, name, title, isSelected, type }) => (
          <Tab
            key={id}
            isCompleted={isCompleted}
            isBeforeSelected={isBeforeSelected}
            isAfterSelected={isAfterSelected}
            isSelected={isSelected}
            id={id}
            name={name}
            title={title}
            onClick={onSelectedTab}
            type={type}
          />
        ))}
      </div>
    );
  }
}
